import React from "react";
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import ThreeColumnWithProfileImage from "components/testimonials/ThreeColumnWithProfileImage";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import styled from "styled-components";
import Slider from "react-slick"; // ✅ import slider
import "slick-carousel/slick/slick-theme.css";

const FullWidthSlider = styled.div`
  width: 100%;
  margin-top: 0px;

  .slick-slide img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  /* ✅ Slider dots styling */
  .slick-dots {
    bottom: -30px;
  }

  .slick-dots li {
    margin: 0 6px;
  }

  .slick-dots li button:before {
    font-size: 10px; /* default dot size */
    color: #ccc;
    opacity: 1;
    transition: all 0.3s ease;
  }

  /* ✅ Active dot larger and colored */
  .slick-dots li.slick-active button:before {
    font-size: 16px; /* larger active dot */
    color: #0f4640; /* match your highlight color */
    opacity: 1;
  }
`;
const sliderSettings = {
  dots: true,
  infinite: true,
  autoplay: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplaySpeed: 2500,
};
const sliderImages = [
  "https://i0.wp.com/cavijenderaggarwal.com/wp-content/uploads/2025/10/top-rankers-1-scaled.jpg?fit=1536%2C391&ssl=1",
  "https://i0.wp.com/cavijenderaggarwal.com/wp-content/uploads/2025/10/Website-1500-x-382-px-4-scaled.jpg?fit=1536%2C391&ssl=1",
  "https://i0.wp.com/cavijenderaggarwal.com/wp-content/uploads/2025/10/3-New-Batch-scaled.jpg?fit=1536%2C391&ssl=1",
  "https://i0.wp.com/cavijenderaggarwal.com/wp-content/uploads/2025/10/Fast-Track-Flyer-1-scaled.jpg?fit=1536%2C391&ssl=1",
  "https://i0.wp.com/cavijenderaggarwal.com/wp-content/uploads/2025/10/4-Recorded-Classes-scaled.jpg?fit=1536%2C391&ssl=1",
];

const Testimonial = () => {
  return (
    <AnimationRevealPage>
      <Header />

      <div>
        <ThreeColumnWithProfileImage />
      </div>
      <Footer />
    </AnimationRevealPage>
  );
};

export default Testimonial;
